//@flow
export const ENTITY_NAME_ID = 'masterLineItem';
export const ENTITY_TABLE_ID = 'LineItemMaster';
export const ENTITY_EXPORT_ID = 'SKU_MASTER';
export const ENTITY_TYPE = 'LINEITEM';
